<div class="is-flex is-column gap-32">
    <app-home-selector></app-home-selector>

    <div class="is-flex is-column gap-16">

      <div [class.control-subsection]="isControlActive()" class="is-flex is-column gap-16">
        <app-sidebar-link
          path="/control"
          icon="control" text="Control">
        </app-sidebar-link>
        <div
          *ngIf="isControlActive() && !isAssistant()"
          class="is-flex is-column gap-16"
          [class.container-sublinks]="(hasCompareOrReportsSubLink$ | async)">
          <app-sidebar-link
            *ngIf="(hasCompareOrReportsSubLink$ | async)"
            [path]="['/control/dashboard']" icon="dashboard-16" [subsection]="true" [text]="'station-app.__DASHBOARD_TITLE' | AsyncLang | async"></app-sidebar-link>
          <app-sidebar-link
            [class.has-red-pill]="hasSeenFusCompare()"
            *ngIf="hasCompareSubLink$ | async"
            [path]="['/control/compare']" icon="graph-16" [subsection]="true" [text]="'common-app.__GRAPH_COMPARISON' | AsyncLang | async"></app-sidebar-link>
          <app-sidebar-link
            [class.has-red-pill]="hasSeenBilan()"

            *ngIf="hasReportsSubLink$ | async"
            [path]="['/control/reports']" icon="pie-chart-16" [subsection]="true" [text]="'common-app.__MY_REPORTS' | AsyncLang | async"></app-sidebar-link>
        </div>

      </div>

    <app-sidebar-link [path]="['/security']" icon="security-app" text="Security"></app-sidebar-link>

    <app-sidebar-link [path]="['/settings']" icon="settings"
      [text]="'common-settings.__MY_SETTINGS' | AsyncLang | async">
    </app-sidebar-link>

    <div class="separator"></div>

    <app-sidebar-link [href]="environment.shopUrl + '?utm_source=webapp_home&utm_medium=referral'" target="_blank" icon="netatmo" [text]="'common-app.__COM_SETTINGS_SHOP' | AsyncLang | async">
    </app-sidebar-link>

    <app-sidebar-link [path]="['/news']" icon="actuality" [class.has-red-pill]="hasSeenNews()"
      [text]="'legrand-app.__LEG_NEWS' | AsyncLang | async">
    </app-sidebar-link>

    <app-sidebar-link [path]="['/help']" icon="help"
      [text]="'common-settings.__MY_HELP' | AsyncLang | async" ga-event="Help">
    </app-sidebar-link>

    <app-sidebar-link [href]="environment.logoutUrl + '?message=__DISCONNECTED&next_url=' + environment.appUrl"
      icon="log-out" [text]="'common-app.__LOGOUT' | AsyncLang | async" ga-event="LogOut">
    </app-sidebar-link>

  </div>

</div>

<div class="is-flex is-column is-align-start gap-12 is-fullwidth">

  <img class="logo" src="assets/images/navbar/brands-logo.svg"/>

  <app-legals-buttons></app-legals-buttons>

</div>
